import { cn } from "@/lib/utils";

import { type TraderListItem } from "./types";

export const DEFAULT_PAGE_SIZE = 20;
export const COMPACT_HEADER_CLASS = "px-3 py-2 !whitespace-normal leading-tight";
export const NUMERIC_HEADER_CLASS = cn(COMPACT_HEADER_CLASS, "text-center");

// Caps numeric columns so the table stays compact and the flexible name column absorbs
// the remaining horizontal space. Wide enough to fit the longest single-word header next
// to its sort icon, while multi-word headers still wrap onto two lines.
export const NUMBER_COLUMN_WIDTH_CLASS = "max-w-32";

export const TRADER_SORT_OPTIONS = [
  { id: "name", translationKey: "traders.list.columns.name", label: "Name" },
  { id: "location_name", translationKey: "traders.list.columns.area", label: "Area" },
  { id: "last_active", translationKey: "traders.list.columns.lastActive", label: "Last active" },
  {
    id: "direct_offers_count",
    translationKey: "traders.list.columns.directOffers",
    label: "Direct offers",
  },
  {
    id: "market_offers_count",
    translationKey: "traders.list.columns.demandOffers",
    label: "Demand offers",
  },
  {
    id: "accepted_count",
    translationKey: "traders.list.columns.offersAccepted",
    label: "Offers accepted",
  },
  {
    id: "exchange_done_count",
    translationKey: "traders.list.columns.exchanges",
    label: "Exchanges",
  },
] as const;

export const SEARCHABLE_TRADER_FIELDS = [
  "name",
  "location_name",
] as const satisfies readonly (keyof TraderListItem)[];
